import {
    Box,
    Grid
} from "@mui/material";

import { CardCurso } from "./CardCurso";


export const GridCursos = ({ cursos }) => {

    const colores = {
        1: "#8F1515",
        2: "#1E3A66",
        3: "#19959B",
    };


    return (

        <Box
            sx={{
                mt: 4,
                mb: 6,
            }}
        >

            <Grid
                container
                
                sx={{
                    mt: 4,
                    justifyContent: "center",
                }}
            >

               {cursos.slice().reverse().map((item) => (

                    <Grid
                        key={item.id}
                        size={{
                            xs: 6,
                            sm: 4,
                            md: 3,
                            lg: 1.8,
                        }}
                    >

                        <CardCurso
                            curso={item}
                            colores={colores}
                        />

                    </Grid>

                ))}

            </Grid>

        </Box>

    );
};